var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 3,
    viewBox: "0 0 13 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.998263 0.588222L7.45038 0.59364L12.0039 0.588276C12.256 0.59364 12.4598 0.797449 12.4598 1.04417L12.4598 1.95594C12.4544 2.20802 12.2506 2.41183 12.0039 2.41183L5.62151 2.41178L0.998263 2.41178C0.746129 2.40647 0.54232 2.20266 0.542374 1.95589L0.542374 1.04411C0.54763 0.792031 0.751439 0.588222 0.998263 0.588222Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.e138bf504c16993183593d6f0091060f.svg";
export { ForwardRef as ReactComponent };